import { __assign } from 'tslib';
import React__default, { useContext } from 'react';
import classNames from 'classnames';
import { CartContext, PARTNERSHIP_WARNING_TRANSITION_DURATION } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../constants/api.esm.js';
import { Cart } from '../Cart/Cart.esm.js';
import { PartnershipCode } from '../PartnershipCode/PartnershipCode.esm.js';
import useCollapsible from '../../utils/hooks/useCollapsible/useCollapsible.esm.js';
import styles from './MiniCart.module.esm.js';

var MINI_CART_TRANSITION_DURATION = 400;
var TooltipMiniCart = function (_a) {
    var actionsContent = _a.actionsContent, arrowRef = _a.arrowRef, className = _a.className, forwardRef = _a.forwardRef, isCursorInsideMiniCart = _a.isCursorInsideMiniCart, partnershipWarning = _a.partnershipWarning, shouldShowPartnershipWarning = _a.shouldShowPartnershipWarning, shouldKeepMiniCartOpen = _a.shouldKeepMiniCartOpen, partnershipCode = _a.partnershipCode, tooltipRef = _a.tooltipRef, getArrowProps = _a.getArrowProps, getTooltipProps = _a.getTooltipProps, placement = _a.placement;
    var miniCartCollapsible = useCollapsible(MINI_CART_TRANSITION_DURATION);
    var partnershipWarningCollapsible = useCollapsible(PARTNERSHIP_WARNING_TRANSITION_DURATION);
    var _b = useContext(CartContext), isUserAuthenticated = _b.isUserAuthenticated; _b.meta;
    React__default.useEffect(function () {
        miniCartCollapsible.toggle(isCursorInsideMiniCart || shouldKeepMiniCartOpen);
    }, [isCursorInsideMiniCart, miniCartCollapsible, shouldKeepMiniCartOpen]);
    React__default.useEffect(function () {
        partnershipWarningCollapsible.toggle(shouldShowPartnershipWarning);
    }, [partnershipWarningCollapsible, shouldShowPartnershipWarning]);
    var handleTooltipRef = function (ref) {
        // Let parent know of tooltip ref to track clicks outside.
        forwardRef.current = ref;
        // Store same ref inside as well to control collapsible.
        miniCartCollapsible.setRef(ref);
    };
    return (React__default.createElement("div", __assign({ className: styles.miniCartWrapper }, getTooltipProps({ ref: tooltipRef })),
        React__default.createElement("div", { className: classNames(styles.miniCart, className), "data-testid": "mini-cart-tooltip", id: "mini-cart-tooltip", ref: handleTooltipRef },
            React__default.createElement("div", __assign({}, getArrowProps({
                'data-placement': placement,
                ref: arrowRef,
            }))),
            React__default.createElement(Cart, { isCompact: true, isEditable: false }),
            React__default.createElement(PartnershipCode, { isInMiniCart: true, partnershipCode: partnershipCode }),
            isUserAuthenticated && actionsContent,
            React__default.createElement("div", { className: styles.partnershipWarning, ref: partnershipWarningCollapsible.setRef },
                React__default.createElement("span", null, partnershipWarning)))));
};

export { MINI_CART_TRANSITION_DURATION, TooltipMiniCart as default };
//# sourceMappingURL=TooltipMiniCart.esm.js.map
